var lib_core  = require("lib-core");

var AbstractEditorController = require("./../../abstract/abstractEditorController.js");
var SnapGridView            = require("./snapGridView.js");
//var GridSnapModel           = require("./gridSnapModel.js");
//var GridSnapStateMachine    = require("./gridSnapStateMachine.js");

var SnapGridController = function(archLayers, dependencies, configuration) {
    lib_core.Controller.call(this, archLayers, dependencies, configuration);
};
lib_core.inherit(SnapGridController, lib_core.Controller);

module.exports = SnapGridController;

SnapGridController.prototype.createView = function () {
	var editorView = this.findUpstream(AbstractEditorController).getView();
    return new SnapGridView(this.root,this.getStatemachine(),editorView,this.model, this.findUpstream("Editor3D").getModel());
};
